import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => {
  const isDark = theme.palette.type === 'dark'

  return {
    boxAttachment: {
      display: 'flex',
      flexDirection: 'column',
      gap: '4px',
      width: '100%',
      // maxWidth: '300px',
      '& span': {
        fontSize: '.875rem',
        color: isDark ? theme.palette.dark_50.main : theme.palette.gray_400.main
      }
    },
    boxAttachmentContainer: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      width: '100%',
    },
    attachmentContainer: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px'
    },
    button: {
      flex: 1,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '8px',
      height: '80px',
      border: isDark
        ? '2px dashed' + theme.palette.dark_stroke.main
        : '2px dashed' + theme.palette.gray_stroke.main,
      borderRadius: '6px',
      padding: '0 16px',
      cursor: 'pointer',
      transition: 'border-color 0.2s'
    },
    buttonsAttachmentFile: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '8px',
      width: '100%',
      height: '90px',
      backgroundColor: isDark
        ? theme.palette.dark_400.main
        : theme.palette.gray_100.main,
      border: isDark
        ? '1px dashed' + theme.palette.dark_stroke.main
        : '1px dashed' + theme.palette.gray_stroke.main,
      borderRadius: '8px',
      padding: '16px'
    },
    buttonsBoxAttachment: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '8px'
    },
    buttonsAttachment: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'flex-end',
      gap: '8px'
    },
    attachmentPreviewImage: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      width: '100%',
      justifyContent: 'center'
    },
    coverImage: {
      // width: '200px',
      width: '100%',
      height: '60px',
      borderRadius: '4px',
      objectFit: 'cover'
    },
    attachmentName: {
      color: isDark ? theme.palette.dark_50.main : theme.palette.gray_400.main,
      fontWeight: 500,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      maxWidth: '160px'
    },
    attachmentNotFile: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '8px',
      fontStyle: 'italic',
      color: isDark ? theme.palette.dark_50.main : theme.palette.gray_400.main
    },
    attachmentFiles: {
      textAlign: 'center',
      color: isDark ? theme.palette.dark_50.main : theme.palette.gray_400.main,
      fontStyle: 'italic',
      fontSize: '11px !important',
      marginTop: '2px'
    },
    boxContainerAttachmentAndActions: {
      display: 'flex',
      alignItems: 'end',
      justifyContent: 'space-between',
      gap: '8px'
    },
    buttonFile: {
      '& .MuiButton-label': {
        display: 'flex',
        gap: '8px'
      },
      backgroundColor: theme.palette.blue_300.main,
      color: theme.palette.white_100.main,
      height: 35,
      borderRadius: 8,
      maxWidth: 250,
      '&:hover': {
        backgroundColor: theme.palette.green_200.main
      },
      '& span': {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
      }
    },
    boxIconButtonDelete: {
      width: '20px',
      height: '20px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0
    },
    iconButtonDelete: {
      color: theme.palette.red_100.main,
      backgroundColor: 'transparent',
      borderRadius: '6px',
      '&:hover': { backgroundColor: 'transparent' },
      '& svg': { color: theme.palette.red_100.main }
    },

    dialogContent: {
      display: 'flex',
      justifyContent: 'center',
      padding: '16px',
      backgroundColor: 'transparent',
      overflow: 'hidden'
    },
    boxPreviewImage: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      gap: '8px',
      '& img': {
        borderRadius: '16px'
      },
      '& span': {
        color: isDark ? theme.palette.dark_50.main : theme.palette.gray_400.main
      }
    },
    zoomImage: {
      width: '100%',
      height: 'auto',
      maxHeight: '80vh',
      objectFit: 'contain'
    },

    dialogActions: {
      borderTop: '1px solid rgba(255, 255, 255, 0.12)'
    }
  }
})
